require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/fn/array/includes.js